module.exports = __webpack_public_path__ + "static/media/Workout.bf3b438d.png";